import _get from 'lodash/get';
import _has from 'lodash/has';
import { ASSESSMENT_COLORS } from 'containers/Assessment/constants';

export const isAssessmentSaved = (savedAssessments, assessment) => {
  const id =
    _get(assessment, 'id') ||
    _get(assessment, 'sys.id') ||
    _get(assessment, 'objectID') ||
    '';
  return savedAssessments && savedAssessments.map(el => el.sys.id).includes(id);
};

export const isAssessmentTaken = (takenAssessments, assessment) => {
  const slug = _has(assessment, 'slug')
    ? assessment.slug
    : _has(assessment, 'fields')
    ? assessment.fields.slug
    : '';
  const id = _has(assessment, 'id')
    ? assessment.id
    : _has(assessment, 'sys')
    ? assessment.sys.id
    : '';
  return (
    (takenAssessments &&
      takenAssessments.map(el => el.assessment.slug).includes(slug)) ||
    (takenAssessments &&
      takenAssessments.map(el => el.assessment.assessmentID).includes(id))
  );
};
// default to aqua in case of broken data
export const getColorAndColorName = item => {
  const colorName = _get(item, 'fields.color') || _get(item, 'color');

  if (colorName) {
    return {
      color: ASSESSMENT_COLORS[colorName.toLowerCase()],
      colorName,
    };
  }

  return {
    color: ASSESSMENT_COLORS.aqua,
    colorName: 'aqua',
  };
};
